import { PatchAttachmentDescriptor, PatchDescriptor } from "@archipad/services/file/patchFile";

export class CacheFileDescriptor extends PatchAttachmentDescriptor {
    public constructor(
        public readonly patch: PatchDescriptor,
        public readonly entityId: string,
        public readonly attachmentKey: string,
        public readonly projectId: string,
        public readonly userId: string,
    ) {
        super(patch, entityId, attachmentKey);
    }

    public get type() {
        return 'localCache' as const;
    }
}
